// GENERATED FILE - DO NOT MODIFY
export enum ServiceCallMaintenanceStatus {
    Complete = 0,
    InProgress = 1,
    NotStarted = 2,
}

export let nameof = "ServiceCallMaintenanceStatus";
